/******/ (() => { // webpackBootstrap
  var __webpack_exports__ = {};
  Shopify.theme.jsTestimonials = {
    init: function ($section) {
      const $testimonialSlider = $section.find('[data-slider]');

      if($(".jsMeettheteam").length >= 1) {
        $testimonialSlider.flickity({
          lazyLoad: 2,
          freeScroll: true,
          groupCells: 1,
          imagesLoaded: true,
          draggable: true,
          cellAlign: 'left',
          wrapAround: true,
          pageDots: false,
          contain: false,
          prevNextButtons: true,
          arrowShape: arrowShape,
          initialIndex: 0
        });
      }else {
        $testimonialSlider.flickity({
          groupCells: 1,
          draggable: true,
          cellAlign: 'left',
          wrapAround: true,
          pageDots: true,
          prevNextButtons: true,
          arrowShape: arrowShape
        });
      }

      // Resize flickity when the slider is settled
      $testimonialSlider.on('settle.flickity', function () {
        $testimonialSlider.flickity('resize');
      });

      $section.on('click', '.testimonial__nav--prev', function () {
        $testimonialSlider.flickity('previous');
      });

      $section.on('click', '.testimonial__nav--next', function () {
        $testimonialSlider.flickity('next');
      });

      $(".testimonial-block").on("click", function () {
        let modal = $(this).data("modal-content");
        $(modal).css("display","block");
      });

      // When the user clicks on <span> (x), close the modal
      $(".meetTeamModal .close").on("click", function () {
        let modal = $(this).closest(".meetTeamModal");
        console.log("modal---",modal);
        $(modal).css("display","none");
      });

    },
    blockSelect: function ($section, blockId) {
      const $testimonialSlider = $section.find('[data-slider]');

      const slideIndex = $('#shopify-section-' + blockId).data('index');

      $testimonialSlider.flickity('select', slideIndex);
    },
    unload: function ($section) {
      const $slider = $section.find('.flickity-enabled');
      $slider.flickity('destroy');
      $('.testimonial__nav--prev').off();
      $('.testimonial__nav--next').off();
    }
  }

  /******/
})()
  ;